import { isValueEmpty, getNumberValuesToCompare, isArrayOfNumbers, between } from "../utils.js";
function valueIsBetween(givenValue, expectedValue) {
  if (isValueEmpty(givenValue)) {
    return false;
  }
  if (!Array.isArray(expectedValue) || expectedValue.length !== 2) {
    throw new Error("Expected value should be array of two elements");
  }
  const values = getNumberValuesToCompare(
    givenValue,
    expectedValue[0],
    expectedValue[1]
  );
  if (isArrayOfNumbers(values)) {
    const [given, firstBound, secondBound] = values;
    return between(
      given,
      Math.min(firstBound, secondBound),
      Math.max(firstBound, secondBound)
    );
  }
  throw new Error(
    `Between operator: Unsupported values to compare ${givenValue}, ${JSON.stringify(
      expectedValue
    )}`
  );
}
export {
  valueIsBetween
};
//# sourceMappingURL=between.js.map
